import React, {useEffect, useRef, useState} from "react";
import {Card, Col, Row, Spin, Tooltip, Typography} from "antd";
import {EditOutlined, InfoCircleOutlined} from "@ant-design/icons";

import AccountFriendlyNameEdit from "./AccountFriendlyNameEdit";
import {getAccount} from "../../helpers/account";
import {messageType, showMessages} from "../../helpers/message";

const {Text} = Typography;

const AccountAdditionalDetails = () => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);

    const [friendlyName, setFriendlyName] = useState(null);
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [refreshAccountInfo, setRefreshAccountInfo] = useState(false);

    const handleClose = async (refresh = true) => {
        setEditing(false);
        if (refresh) {
            setRefreshAccountInfo(!refreshAccountInfo);
        }
    };

    const onEdit = () => {
        setEditing(true);
    };

    // When component mounts.
    useEffect(() => {
        const fetchInfo = async () => {
            try {
                setLoading(true);
                const abortSignal = abortSignalRef.current;
                const data = await getAccount(abortSignal);

                if (data) {
                    setFriendlyName(data.friendly_name);
                    setLoading(false);
                }
            } catch (error) {
                showMessages(error.message, messageType.error);
                setLoading(false);
                if(error.status_code === 404) window.location.replace('/404');
            }
        };
        fetchInfo();
    }, [refreshAccountInfo]);

    // Cleanup effect when component unmounts.
    useEffect(() => {
        const abortController = abortControllerRef.current;
        return function abort() {
            abortController.abort();
        }
    }, []);

    return (
        <div>
            <Spin spinning={loading}>
                <Card
                    title={<Typography.Text strong>Additional Details</Typography.Text>}
                    extra={<EditOutlined key="edit" onClick={onEdit}/>}
                    className="details-card"
                >
                    <Row>
                        <Col xs={24} sm={12} md={10}>
                            <span><Text strong> Friendly Name:</Text></span>
                            <Tooltip
                                title="If you have multiple accounts, you can provide each with
                                       friendly name for easy reference (eg. My personal account)"
                            >
                                <InfoCircleOutlined/>
                            </Tooltip>
                        </Col>
                        <Col xs={24} sm={12} md={14}>
                            <div
                                style={{wordWrap: "break-word"}}>{friendlyName ? friendlyName : 'N/A'}</div>
                        </Col>
                    </Row>
                </Card>
                {
                    editing &&
                    <AccountFriendlyNameEdit
                        friendlyNameProp={friendlyName}
                        handleClose={handleClose}
                        visible={editing}
                    />
                }
            </Spin>
        </div>
    );
}

export default AccountAdditionalDetails;

AccountAdditionalDetails.propTypes = {};
